import { render, staticRenderFns } from "./container_demand_detail.vue?vue&type=template&id=f4628934&scoped=true&"
import script from "./container_demand_detail.vue?vue&type=script&lang=js&"
export * from "./container_demand_detail.vue?vue&type=script&lang=js&"
import style0 from "./container_demand_detail.vue?vue&type=style&index=0&id=f4628934&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4628934",
  null
  
)

export default component.exports